import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Constants from "../Constants";
const NotFound = () => {
  return (
    <div className="main">
      <Helmet>
        <title>Not Found</title>
      </Helmet>
      <div className="info2257">
        <h1>Oops! Could not find this Page.</h1>
        <p>
          The Page you were looking for could not be found!{" "}
          <Link to={`${Constants.HOME}`}>Please head back Home.</Link>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
